import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  inject,
  PLATFORM_ID
} from '@angular/core';
import { UserSessionService } from 'src/shared/service/user-session.service';
import { SharedUiLibraryModule } from '@cudirect/shared-ui-library';
import { NgxMaskPipe } from 'ngx-mask';
import { isPlatformBrowser } from '@angular/common';

/**
 * Component representing User session section
 * @Component
 */
@Component({
  selector: 'cu-user-session',
  styleUrls: ['./user-session.component.scss'],
  templateUrl: './user-session.component.html',
  standalone: true,
  imports: [SharedUiLibraryModule, NgxMaskPipe]
})
export class UserSessionComponent implements OnInit, OnDestroy, AfterViewInit {
  @Output() public continueClick = new EventEmitter<boolean>();
  @Output() public logoutClick = new EventEmitter<boolean>();
  // Inject dependencies using the new inject pattern
  private readonly userSession = inject(UserSessionService);
  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  @ViewChild('refresh') btnRefresh: ElementRef<HTMLElement>;
  @ViewChild('cancel') btnCancel: ElementRef<HTMLElement>;
  @ViewChild('sessionpopup') divSessionpopup: ElementRef<HTMLElement>;
  /** Returns expiration day */
  public expiration: number;
  /** Returns minutes */
  public minutes: string;
  /** Returns seconds */
  public seconds: string;
  /** Returns interval */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public interval: any;

  public ngOnInit(): void {
    this.expiration = new Date(new Date().setMilliseconds(60000)).getTime(); // 1 Minute warning for inactivity

    this.startUICountDown();
  }

  public ngAfterViewInit(): void {
    if (this.isBrowser) {
      setTimeout(() => {
        this.divSessionpopup.nativeElement.focus();
        this.btnRefresh.nativeElement.focus();
      }, 10);
    }
  }

  public logOut(): void {
    if (this.isBrowser) {
      sessionStorage.removeItem('registration');
    }
    this.userSession.logOut(true, true);
    this.logoutClick.emit(true);
  }

  public continueSession(): void {
    this.userSession.closeModal();
    this.continueClick.emit(true);
  }

  public ngOnDestroy(): void {
    clearInterval(this.interval);
  }

  private startUICountDown(): void {
    const number1000 = 1000;
    const number60 = 60;
    this.interval = setInterval(() => {
      const now = new Date().getTime();
      const timeLeft = this.expiration - now;

      this.minutes = Math.floor((timeLeft % (number1000 * number60 * number60)) / (number1000 * number60)).toString();
      if (this.minutes.length === 1) {
        this.minutes = String(0) + this.minutes;
      }
      this.seconds = Math.floor((timeLeft % (number1000 * number60)) / number1000).toString();
      if (this.seconds.length === 1) {
        this.seconds = String(0) + this.seconds;
      }

      if (timeLeft < number1000) {
        clearInterval(this.interval);
        this.logOut();
      }
    });
  }

  public onTabKeyEvent(evt: Event): void {
    const id = 'id';
    const btnName = evt.currentTarget[id];
    evt.preventDefault();
    if (btnName === 'refresh') {
      this.btnCancel.nativeElement.focus();
      return;
    }

    this.btnRefresh.nativeElement.focus();
  }
}
